// extracted by mini-css-extract-plugin
export var column = "_td-0";
export var divider = "_td-2";
export var timePicker = "_td-1";